<template>
  <div class="question mt-2 py-1" v-if="question">
    <span v-if="question.starts">
      {{ $t('GAME.RONDO.STARTS_WITH') }} <strong>{{ char }}</strong>
    </span>
    <span v-else>
      {{ $t('GAME.RONDO.CONTAINS') }} <strong>{{ char }}</strong>
    </span>
  </div>
</template>

<style scoped lang="scss">
.question {
  background: var(--v-secondary-base);
  border-radius: $box-radius;
  text-align: center;
  width: 200px;
}

strong {
  text-transform: uppercase;
}

@media screen and (max-width: 410px) {
  .question {
    width: 150px;
    font-size: .8em;
  }
}
</style>

<script>
export default {
  name: 'QuestionStartContains',
  computed: {
    question() {
      return this.$store.getters['rondo/current'] || {};
    },
    char() {
      const { current } = this.$store.state.rondo;
      return current;
    },
  },
};
</script>
